module.exports = __webpack_public_path__ + "static/media/sms-promotional.17c119eb.png";